module.exports = __webpack_public_path__ + "img/flag-CA.283d69cf.svg";